import { isPostCommentTimelineItem, isPostEventTimelineItem, type PostTimeline } from './types.no-deps'
import type { PostEvent } from '../postEvents/types.no-deps'
import type { BackwardsCompatiblePostComment } from '../postComments/types.no-deps'
import { pipe } from '../../lib/functional/pipe.no-deps'
import { filter, mapField } from '../../lib/functional/array.no-deps'

export function getPostEvents(timeline: PostTimeline): PostEvent[] {
    return pipe(timeline, filter(isPostEventTimelineItem), mapField('event'))
}

export function getComments(timeline: PostTimeline): BackwardsCompatiblePostComment[] {
    return pipe(timeline, filter(isPostCommentTimelineItem), mapField('comment'))
}
